import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import {
  updateCourseOffer,
  getInitialValuesFromExistingCourseOffer
} from '../../services/courseOfferService';
import CourseOfferForm from './CourseOfferForm';
import moment from 'moment';
import { validateLink } from '../../utilities/formValidator';

function CourseOfferEdit({
  courseOffer,
  isCohortCourseEditMode,
  isOpen,
  course,
  isPricingModalVisible,
  setIsPricingModalVisible,
  onCancelModal
}) {
  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

  const [initialValues, setInitialValues] = useState(
    getInitialValuesFromExistingCourseOffer(courseOffer, 'edit')
  );

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    let payload = {
      ...values,
      startDate: moment(values.startDate, dateFormat).utc().format(),
      endDate: moment(values.endDate, dateFormat).utc().format()
    };

    if (payload.setReleaseDate) payload.releaseDate = payload.startDate;
    else payload.releaseDate = null;

    if (!validateDate(payload.startDate, payload.endDate)) {
      setStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!'
      });
    } else if (
      !validateMaxAndMin(
        payload.maxRegistrations,
        payload.minRegistrations
      )
    ) {
      setStatus({
        type: 'ERROR',
        message: 'Max Registrations cannot be less than Min Registrations!'
      });
    } else if (!validateLink(payload.whatsappGroupLink, true)) {
      setStatus({
        type: 'ERROR',
        message: 'Whatsapp Link is not valid'
      });
    } else {
      setStatus({ type: 'LOADING', message: 'Request in Progress!' });
      await updateCourseOffer(courseOffer.courseOfferId, payload)
        .then((response) => {
          updateCourseOffer({
            ...response.data.courseOffer,
            startDate: moment(response.data.courseOffer.startDate).format(
              dateFormat
            ),
            endDate: moment(response.data.courseOffer.endDate).format(
              dateFormat
            )
          });
          setStatus({
            type: 'SUCCESS',
            message: 'Data updated successfully!'
          });
          setInitialValues(payload);
        })
        .catch((error) => {
          alert('Getting data from the backend failed!');
          if (error?.response?.data?.message)
            setStatus({
              type: 'ERROR',
              message: error.response.data.message
            });
          else
            setStatus({ type: 'ERROR', message: 'Something went wrong!' });
        });
    }
  };

  const validateDate = (startDate, endDate) => {
    return new Date(startDate).getTime() < new Date(endDate).getTime();
  };

  const validateMaxAndMin = (max, min) => {
    return max >= min;
  };

  return (
    <Modal
      title={`Edit Course Offer ${courseOffer.courseOfferId}`}
      visible={isOpen}
      onCancel={() => onCancelModal()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <CourseOfferForm
          type="Update"
          isCohortCourseEditMode={isCohortCourseEditMode}
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          course={course}
          visible={isOpen}
          isPricingModalVisible={isPricingModalVisible}
          setIsPricingModalVisible={setIsPricingModalVisible}
        />
      )}
    </Modal>
  );
}

export default CourseOfferEdit;
